(function () {
    'use strict';
    angular.module('AngularAdmin')

        .directive('pdProductionCalendar', ["$rootScope", function ($rootScope) {
            return {
                restrict: "E",
                templateUrl: '/static/partials/production_calendar.html',
                controller: 'ProductionCalendarCtrl',
                replace: true,
                scope: true,
                require: 'pdCalendar',
                link: function ($scope, $element, $attr) {

                    $scope.isHoveredEntry = function (entry) {
                        return entry && entry.id && $scope.hoveredEntry == entry.id;
                    };

                    $scope.setHoveredEntry = function (entry) {
                        $scope.hoveredEntry = entry && entry.id;
                    };
                }
            };
        }])

        .directive('pdProductionCalendarDayCell', [function () {
            return {
                restrict: "A",
                templateUrl: '/static/partials/production_calendar_day_cell.html',
                link: function ($scope, $element, $attr) {

                }
            };
        }]);
})();
